import { useLocation } from 'react-router-dom';

// Where a detail page's Back link goes: the list URL the user came from,
// carried in router state, or the fallback for deep links.
export function useBackTo(fallback: string): string {
  const location = useLocation();
  const from = location.state?.from;

  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')
    ? from
    : fallback;
}

// Router state for a row click, so the detail page can return here.
export function fromHere(location: { pathname: string; search: string }): { from: string } {
  return { from: location.pathname + location.search };
}
